export default __webpack_public_path__ + "static/hubertd-f33a23bde0b43649fd5f5ff1990dc63f.png";